<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Chips
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content content--modifier-height">
  <h2>Customized Chips</h2>

  <div class="content__tools-wrap">
    <div class="content__row">
      <label for="size" class="content__row-label">size</label>
      <select [(ngModel)]="selectedSize" class="c-input-group__control" id="size">
        <ng-container *ngFor="let size of sizeList">
          <option [value]="size">{{ size }}</option>
        </ng-container>
      </select>
      <label for="status" class="content__row-label">status</label>
      <select [(ngModel)]="selectedStatus" class="c-input-group__control" id="status">
        <ng-container *ngFor="let status of statusList">
          <option [value]="status">{{ status }}</option>
        </ng-container>
      </select>
      <input type="text" placeholder="Icon" [(ngModel)]="icon" aria-label="Icon name" class="c-input-group__control" id="inputicon" />
      <label for="inputicon" class="u-display-none">Icon name</label>
      <input type="text" id="ariaLabel" class="c-input-group__control" aria-label="Aria Label" placeholder="Aria Label"
        [(ngModel)]="ariaLabel" />
      <label for="ariaLabel" class="u-display-none">Aria Label</label>
      <input type="text" id="iconText" class="c-input-group__control" aria-label="Icon Text" placeholder="Icon Text"
        [(ngModel)]="iconText" />
      <label for="iconText" class="u-display-none">Icon Text</label>
    </div>

    <div class="content__row">
      <div class="c-input-check-inline">
        <input id="inlineCheckbox1" class="c-input-check-inline__input" type="checkbox" name="hasCloseButton"
          [(ngModel)]="hasCloseButton">
        <label for="inlineCheckbox1" class="c-input-check-inline__label">Has Close Button</label>
      </div>
      <div class="c-input-check-inline">
        <input id="inlineCheckbox2" class="c-input-check-inline__input" type="checkbox" name="hasOutline"
          [(ngModel)]="hasOutline">
        <label for="inlineCheckbox2" class="c-input-check-inline__label">Has Outline</label>
      </div>
      <div class="c-input-check-inline">
        <input id="inlineCheckbox3" class="c-input-check-inline__input" type="checkbox" name="disabled"
          [(ngModel)]="disabled">
        <label for="inlineCheckbox3" class="c-input-check-inline__label">Disable</label>
      </div>
      <div class="c-input-check-inline">
        <input id="inlineCheckbox4" class="c-input-check-inline__input" type="checkbox" name="hasStatusIcon"
          [(ngModel)]="hasStatusIcon">
        <label for="inlineCheckbox4" class="c-input-check-inline__label">Has Status Icon</label>
      </div>
    </div>
  </div>

  <maced-chip chipId="chipId_12" [iconText]="iconText" label="Label" [status]="selectedStatus" [size]="selectedSize" [hasOutline]="hasOutline"
    [disabled]="disabled" [hasCloseButton]="hasCloseButton" [icon]="icon" [hasStatusIcon]="hasStatusIcon"
    [ariaLabel]="ariaLabel" [hasTabIndex]="true" chipRole="button" [isParamIdSplit]="false">
  </maced-chip>
</div>